const map = {
	"./AutoWateringSchem.jpg": 2680,
	"./BookTrader.png": 7387,
	"./CalCheck.png": 3596,
	"./Depreak Gameplay.png": 4232,
	"./Fert.png": 953,
	"./GitRecording.png": 5149,
	"./GravityFallsTheme.jpg": 9285,
	"./MDE_HMI.png": 6029,
	"./MIPS Simulator.png": 6675,
	"./MosaicPictureGenerator.png": 8289,
	"./PicFromTexts.png": 8156,
	"./Pokeball.jpg": 5432,
	"./SmartHome.png": 4504,
	"./Stackmat.jpg": 2066,
	"./TetrisPuzzle.png": 3563,
	"./TetroRhythm.gif": 8947,
	"./TextTransformer.png": 3724,
	"./Xpira.png": 692,
	"./chess.png": 2594,
	"./likh.png": 4792
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;